import type { ContextGuards } from './types.js';

export function isAgencyCompany(ctx: ContextGuards) {
  return ctx.profileService.isAgencyCompany();
}
